import {ParsedSearchParams} from './types';

const parseChangeSubscriptionFormData = (data: {[k: string]: unknown}) => {
    const query: ParsedSearchParams = {};

    Object.keys(data)
        .sort()
        .forEach((key) => {
            if (data[key] === true) query[key] = '1';
            else if (data[key] === false) delete query[key];
            else query[key] = String(data[key]);
        });

    return query;
};

export default parseChangeSubscriptionFormData;
